<template>
  <div  style="width: 100%">
    <router-view></router-view>
  </div>
</template>

<script>
export default {

}
</script>

<style>
textarea {
   background-color: white !important;
}
</style>